<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		@if (instruction.rate) {
			<app-instruction-box>{{ instruction.rate.value }} {{ instruction.rate.unit }}</app-instruction-box>
		}
		@if (instruction.totalRate) {
			<app-instruction-box>{{ instruction.totalRate.value }} {{ instruction.totalRate.unit }}</app-instruction-box>
		}
		@if (instruction.dose) {
			<app-instruction-box>{{ instruction.dose.value }} {{ instruction.dose.unit }}</app-instruction-box>
		}
	}
</ng-template>